var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 15.4375C14.3462 15.4375 15.4375 14.3462 15.4375 13C15.4375 11.6538 14.3462 10.5625 13 10.5625C11.6538 10.5625 10.5625 11.6538 10.5625 13C10.5625 14.3462 11.6538 15.4375 13 15.4375Z",
    fill: "#8493B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 23.5625C14.3462 23.5625 15.4375 22.4712 15.4375 21.125C15.4375 19.7788 14.3462 18.6875 13 18.6875C11.6538 18.6875 10.5625 19.7788 10.5625 21.125C10.5625 22.4712 11.6538 23.5625 13 23.5625Z",
    fill: "#8493B2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 7.3125C14.3462 7.3125 15.4375 6.22119 15.4375 4.875C15.4375 3.52881 14.3462 2.4375 13 2.4375C11.6538 2.4375 10.5625 3.52881 10.5625 4.875C10.5625 6.22119 11.6538 7.3125 13 7.3125Z",
    fill: "#8493B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.f9c8bc07d4df7af24b38107ada71c2ba.svg";
export { ForwardRef as ReactComponent };